// extracted by mini-css-extract-plugin
export default {"paper":"App_paper__8CPy4","container":"App_container__Rt8T2"};